/**
 * @exmaple ``{
  KYC_1 = 'KYC_1',
  KYC_2 = 'KYC_2',
  KYB_1 = 'KYB_1'
}``

 */
export enum Requirements {
  KYC = 'KYC'
}

export enum RequirementsStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
